{
  "google-maps-embed-iframe-dialog": {
    "buttons": {
      "close": "Schließen"
    }
  }
}
